import { CommandStep, GroupStep } from "~/lib/pipeline";
import JobGroup from "~/components/build/Header/pipeline/utils/jobGroup";
import { Job } from "~/components/build/Show/lib/types";
import { Badge } from "~/components/build/Show/routes/steps/list/-components/Badge";

export const StatsJobCount = ({
  step,
  showLabel = false,
}: {
  step: CommandStep;
  showLabel?: boolean;
}) => {
  if (Features.BuildPageListView) {
    return (
      <Badge className="tabular-nums">
        {step.statistics?.jobsFinishedCount}/{step.statistics?.jobsCount}
        {showLabel && (
          <span className="container-hidden @xl/list:inline">
            &nbsp;{step.statistics?.jobsCount === 1 ? "job" : "jobs"}
          </span>
        )}
      </Badge>
    );
  }

  return (
    <span className="text-charcoal-700 rounded-sm border border-slate-500 bg-white px-1 tabular-nums">
      {step.statistics?.jobsFinishedCount}/{step.statistics?.jobsCount}
    </span>
  );
};

// Given an array of jobs, display a count of the number of passed jobs in that group.
// This is useful for parallel, matrix and group steps.
export const JobCount = ({ jobs, step }: { jobs: Array<Job>; step: CommandStep | GroupStep }) => {
  const jobGroup = new JobGroup(step.uuid);

  for (const job of jobs) {
    jobGroup.appendJob(job);
  }

  if (Features.BuildPageListView) {
    return (
      <Badge className="tabular-nums">
        {jobGroup.finishedCount}/{jobGroup.total || jobGroup.jobs.length}
      </Badge>
    );
  }

  return (
    <span className="text-charcoal-700 rounded-sm border border-slate-500 bg-white px-1 tabular-nums">
      {jobGroup.finishedCount}/{jobGroup.total || jobGroup.jobs.length}
    </span>
  );
};
